import { DropdownMenuItemKind } from "~/shared/enums";
import type { DropdownMenuItem } from "~/shared/types";

export const MAX_ITEMS_PER_SECTION = 5;

export const ROW_TYPE = {
  SECTION_START: "section-start",
  SECTION_END: "section-end",
  ITEM: "item",
  SHOW_MORE: "show-more",
  ACTION: "action",
};

export const makeDropdownItem = (
  isSelected: boolean,
  isMobile: boolean,
  item: Omit<DropdownMenuItem, "kind" | "disabled" | "selected">
): DropdownMenuItem => ({
  ...item,
  kind: DropdownMenuItemKind.BUTTON,
  disabled: isSelected && !isMobile,
  selected: isSelected && isMobile,
});

export const GLOBAL_POPPER_IGNORE_ATTR = "data-global-popper-ignore";
